import { Link } from "react-router-dom";
import { Map as MapIcon, ArrowRight } from "lucide-react";

export const CoverageCTA = ({ kind = "homes" }) => (
  <Link
    to="/coverage"
    data-testid="coverage-cta"
    className="group mt-12 block rounded-2xl border border-border bg-card/50 backdrop-blur overflow-hidden transition-colors hover:border-accent/50"
  >
    <div className="flex items-center gap-5 p-6 sm:p-7 relative">
      <div
        className="absolute inset-0 opacity-[0.07] pointer-events-none"
        style={{ background: "radial-gradient(500px circle at 12% 50%, #3b82f6, transparent 60%)" }}
      />
      <div className="shrink-0 w-12 h-12 rounded-xl border border-accent/40 bg-accent/10 flex items-center justify-center">
        <MapIcon className="w-5 h-5 text-accent" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono-data text-[10px] uppercase tracking-[0.2em] text-accent mb-1">Coverage Map</div>
        <div className="font-display text-lg leading-tight">
          Explore {kind === "vehicles" ? "vehicle" : "home"} inventory across every state we track
        </div>
        <p className="text-sm text-muted-foreground mt-1">
          A live density heatmap — drill into any {kind === "vehicles" ? "city" : "ZIP"}, compare markets, and read the pulse.
        </p>
      </div>
      <div className="shrink-0 flex items-center gap-1.5 font-mono-data text-xs uppercase tracking-wider text-muted-foreground group-hover:text-accent transition-colors">
        Open<ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
      </div>
    </div>
  </Link>
);
